/**
 * @file AuthorProfile/constants.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Felipe Ballesteros [felipe.ballesteros@cbc.ca]
 */

export const AUTHOR_PROFILE_PAGE_IMAGE_DERIVATIVE_WIDTHS = [256, 512, 768];
export const AUTHOR_PROFILE_PAGE_IMAGE_SIZE = ["256px"];

export const DETAIL_PAGE_AUTHOR_IMAGE_DERIVATIVE_WIDTHS = [192, 288];
export const DETAIL_PAGE_AUTHOR_IMAGE_SIZE = ["96px"];

export const AUTHOR_IMAGE_RATIO = "square";
